import {Button, Text} from '@/components-v2/atoms'
import {Dropdown} from '@/components-v2/molecules'
import {useRewardItem} from '@/containers/Promotions/components/PromotionsConditions/Rewards/useRewardItem'
import {Constants} from '@/utils/constants/commonConstants'
import {RewardTypes} from '@/utils/constants/promotionConstants'
import {Icon} from '@pepsico-ds/ui'
import {RewardDiscount} from './RewardDiscount'
import {RewardFreeProducts} from './RewardFreeProducts'
import {RewardGiftItem} from './RewardGiftItem'
import {RewardPoints} from './RewardPoints'

/**
 * v2 reward type picker followed by the inputs for the selected reward type.
 * State and handlers live in useRewardItem, shared with the legacy view.
 */
export const RewardItem = ({promotionCondition, index, rewardIndex = 0, showDeleteLayer = true}) => {
  const {
    rewardOptions,
    rewardType,
    rewardValue,
    selectedDiscountType,
    isMaxDiscountExceeded,
    canDeleteLayer,
    handleSelectedRewardItem,
    handleDeleteLayer,
    handleEditMaxDiscount,
  } = useRewardItem({promotionCondition, rewardIndex})

  const rewardProps = {index, rewardIndex, promotionCondition}

  const getRewardTypeContent = () => {
    switch (rewardType) {
      case RewardTypes.FREE_PRODUCT:
        return <RewardFreeProducts {...rewardProps} />
      case RewardTypes.DISCOUNT:
        return <RewardDiscount {...rewardProps} showDynamicPlaceholder />
      case RewardTypes.GIFT_ITEM:
        return <RewardGiftItem {...rewardProps} />
      case RewardTypes.POINTS:
        return <RewardPoints {...rewardProps} />
      case RewardTypes.PERCENTAGE_DISCOUNT:
        return <RewardDiscount {...rewardProps} showDynamicPlaceholder discountType={selectedDiscountType} />
      case RewardTypes.CASH_DISCOUNT:
        return <RewardDiscount {...rewardProps} discountType={selectedDiscountType} />
      default:
        return null
    }
  }

  const rewardTypeContent = getRewardTypeContent()

  return (
    <>
      <Dropdown
        childList={rewardOptions ?? []}
        placeholder={Constants.Select}
        selectedValue={rewardValue}
        setSelectedValue={handleSelectedRewardItem}
        isClearable={false}
        isRequired={true}
        disabled={index > 0 || rewardIndex > 0}
        selection="single"
        autoComplete="off"
      />
      {rewardTypeContent && (
        <>
          <Text>,</Text>
          {rewardTypeContent}
        </>
      )}
      {showDeleteLayer && canDeleteLayer && (
        <Button variant="tertiary" size="small" text="Delete layer" onClick={handleDeleteLayer} />
      )}
      {isMaxDiscountExceeded && (
        <>
          <span className="flex items-center gap-1 text-[var(--color-text-secondary)]">
            <Icon icon="info" size="small" />
            <Text size="small">Discount % exceeds max</Text>
          </span>
          <Button
            variant="tertiary"
            size="small"
            text="Edit Max"
            iconLeading="mode_edit"
            onClick={handleEditMaxDiscount}
          />
        </>
      )}
    </>
  )
}
